import React from "react";
import API from "../base/API";
import { Modal } from "react-bootstrap";
import { getUser } from "../auth/Auth"
import { translate } from "../base/Translation";

export default class OppositionCommentFormEdit extends React.Component {

    constructor(props) {
        super(props);

        this.api = new API({
            get_form: "/form/fetch/:form",
            save_comment: "/opposition/comment/save/:comment"
        });

        this.state = {
            comment: this.props.comment
        }
    }

    componentDidMount() {
    }

    onSave() {
        this.api.request({
            route: "save_comment",
            params: { comment: this.state.comment.id },
            data: this.state.comment,
            created: (response) => {
                alert(translate("Komentár bol úspešne uložený."));
                this.props.reload();
                this.close();
                window.dispatchEvent(new Event("reloadLog"));
            }
        })
    }

    close() {
        this.setState({ showModal: false });
    }

    open() {
        this.setState({ showModal: true });
    }

    render() {
        if (getUser().role !== parseInt(this.state.comment.user_role, 10)) {
            return <span/>
        }

        if (!this.state.showModal) {
            return (
                <small>&#9702; <a style={{ cursor: "pointer" }} onClick={this.open.bind(this)}>{translate("Upraviť")}</a></small>
            )
        }

        return (
            <Modal show={this.state.showModal} onHide={this.close.bind(this)}>
                <Modal.Header closeButton>
                    <Modal.Title>{translate("Upraviť komentár")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <textarea className="form-control" defaultValue={this.state.comment.text} onBlur={(evt) => {
                            let comment = this.state.comment;
                            comment["text"] = evt.target.value;
                            this.setState({ comment });
                        }} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={this.onSave.bind(this)}><i className="fa fa-save" />&nbsp; {translate("Uložiť")}</button>
                    <button className="btn btn-danger" onClick={this.close.bind(this)}><i className="fa fa-close" />&nbsp; {translate("Zrušiť zmeny")}</button>
                </Modal.Footer>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/opposition/OppositionCommentFormEdit.jsx